import React, { useEffect, useRef } from 'react';
import { problemData } from '../../data/mock';

const ProblemSection = () => {
  const sectionRef = useRef(null);
  const tasksRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    tasksRef.current.forEach((task) => {
      if (task) observer.observe(task);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="section-light section-padding">
      <div className="container" style={{ padding: '0 5%' }}>
        <div 
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
            gap: '80px',
            alignItems: 'center',
          }}
        >
          {/* Content */}
          <div ref={sectionRef} className="fade-in">
            <h2 
              className="section-title section-title-light"
              style={{ maxWidth: '500px' }}
            >
              {problemData.title}
            </h2>
            <p 
              style={{
                fontSize: '18px',
                color: '#4a4a4a',
                marginBottom: '32px',
              }}
            >
              {problemData.description}
            </p>

            {/* Animated Tasks */}
            <div 
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '12px',
                marginBottom: '40px',
              }}
            >
              {problemData.tasks.map((task, i) => (
                <span
                  key={task}
                  ref={(el) => (tasksRef.current[i] = el)}
                  className="stagger-item"
                  style={{
                    background: '#f5f5f5',
                    padding: '10px 20px',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#333',
                    border: '1px solid #e0e0e0',
                    transitionDelay: `${i * 0.1}s`,
                  }}
                >
                  {task}
                </span>
              ))}
            </div>

            {/* Insight Box */}
            <div 
              style={{
                background: 'linear-gradient(135deg, #fff5f0, #fff)',
                border: '1px solid rgba(240, 106, 21, 0.2)',
                padding: '24px',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: '4px',
                  background: '#f06a15',
                }}
              />
              <p 
                style={{
                  fontSize: '16px',
                  color: '#333',
                  fontWeight: 500,
                  lineHeight: 1.6,
                  margin: 0,
                }}
              >
                {problemData.insight}
              </p>
            </div>
          </div>

          {/* Image */}
          <div 
            style={{
              position: 'relative',
            }}
          >
            <div 
              style={{
                position: 'relative',
                borderRadius: '4px',
                overflow: 'hidden',
                boxShadow: '0 30px 80px rgba(0, 0, 0, 0.15)',
              }}
            >
              <img 
                src={problemData.image}
                alt="Complexity of multiple tools"
                style={{
                  width: '100%',
                  height: '400px',
                  objectFit: 'cover',
                }}
              />
              {/* Overlay */}
              <div 
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(135deg, rgba(240, 106, 21, 0.1), transparent)',
                }}
              />
            </div>
            {/* Decorative Element */}
            <div 
              style={{
                position: 'absolute',
                top: '-20px',
                right: '-20px',
                width: '100px',
                height: '100px',
                border: '2px solid #f06a15',
                opacity: 0.3,
                zIndex: -1,
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
